import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { config } from './lib/config.runtime'
import { documentTitle } from './lib/config'
import { buildPublicClientApplication } from './lib/auth'
import './styles/global.css'

// index.html carries the plain "OTilie" as the pre-JS fallback; the env
// suffix (dev/local) is applied here so browser tabs are distinguishable.
document.title = documentTitle(config.appEnv)

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Missing #root element')

// Bootstrap the PCA outside React when running against Entra: build, init, and
// run handleRedirectPromise BEFORE createRoot.render so MsalProvider mounts
// with a settled instance. Doing this inside a useEffect (the prior pattern)
// races MsalProvider's event subscription against MSAL's LOGIN_SUCCESS event,
// which makes the redirect-back land on the unauth branch until a reload.
if (config.auth.kind === 'entra') {
  void buildPublicClientApplication(config.auth).then((pca) => {
    createRoot(rootEl).render(
      <StrictMode>
        <MsalProvider instance={pca}>
          <App />
        </MsalProvider>
      </StrictMode>,
    )
  })
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
